import { ComboboxItem, Select } from "@mantine/core";
import { useMemo } from "react";

type IYearSelectProps = {
  value: string;
  title?: string;
  onChange: (year: string | null, option: ComboboxItem) => void;
};

const YearSelect = ({ value, title, onChange, ...rest }: IYearSelectProps) => {
  const currentYear = new Date().getFullYear();

  const yearOptions = useMemo(() => {
    return Array.from({ length: 5 }, (_, i) => {
      const year = (currentYear - i).toString();
      return { value: year, label: year };
    });
  }, [currentYear]);

  return (
    <Select
      title={title}
      label="Select Year"
      placeholder="Pick a year"
      data={yearOptions}
      w={100}
      value={value}
      onChange={onChange}
      comboboxProps={{
        withinPortal: true,
        zIndex: 3001,
      }}
      clearable
      {...rest}
    />
  );
};

export default YearSelect;
